










































import Vue from 'vue'
import { mapState } from 'vuex'
import { ClipboardService } from '@/core/clipboard'
import SpiderForm from '@/components/spider-form.vue'
import SourceSample from '@/components/source-sample.vue'

const clipboard = new ClipboardService()

export default Vue.extend({
  components: {
    SpiderForm,
    SourceSample,
  },
  data: () => ({
    tab: 0,
    spider: {
      source: {
        name: '',
      },
      settings: {
        'start_urls': '',
        'allowed_domains': '',
        'rules_allow': '',
      },
      status: 'NEW',
      cooldown: 3600,
      additional: false,
      'plugin_id': '',
    },
    errors: {},
  }),
  computed: mapState('auth', {
    user: (state: any) => state.user,
  }),
  methods: {
    copy() {
      const clone = { ...this.spider }
      clone['id'] = undefined

      clipboard
        .write(clone)
        .then(() => {
          this.$toastSuccess.fire({ title: 'Скопировано в буфер' })
        })
        .catch(() => {
          this.$toastError.fire({ title: 'Ошибка копирования в буфер' })
        })
    },
    paste() {
      clipboard
        .read()
        .then(data => {
          Object.assign(this.spider, data)
          this.$toastSuccess.fire({ title: 'Настройки добавлены из буфера' })
        })
        .catch(() => {
          this.$toastError.fire({ title: 'Ошибка добавления настроек из буфера' })
        })
    },
    create() {
      this.$store
        .dispatch('spiders/CREATE', this.spider)
        .then(({ data }) => {
          this.$toastSuccess.fire({
            title: 'Парсер сохранен',
          })
          this.$router.push({ name: 'SpiderDetail', params: { id: data.id } })
        })
        .catch(r => {
          this.errors = r.response?.data ?? {}
          this.$toastError.fire({
            title: 'Ошибка сохранения парсера',
          })
        })
    },
    goBack() {
      this.$router.back()
    },
  },
})
